import React from "react";
import PackagesListing from "./PackagesListing";

function Packages() {
  const type = "all";
  const title = "Products";

  return <PackagesListing type={type} title={title} />;
}

export default Packages;
